"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * PlumbingWorld-3.0
 * PlumbingWorld API
 *
 * Contact: jspencer@juliusspencer.co.nz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERPToJSON = exports.ERPFromJSONTyped = exports.ERPFromJSON = exports.ERP = void 0;
/**
 * The ERP the order was originally stored in (could be empty if failed erp)
 * @export
 * @enum {string}
 */
var ERP;
(function (ERP) {
    ERP["FRAMEWORKS"] = "FRAMEWORKS";
    ERP["DYNAMICS"] = "DYNAMICS";
})(ERP = exports.ERP || (exports.ERP = {}));
function ERPFromJSON(json) {
    return ERPFromJSONTyped(json, false);
}
exports.ERPFromJSON = ERPFromJSON;
function ERPFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.ERPFromJSONTyped = ERPFromJSONTyped;
function ERPToJSON(value) {
    return value;
}
exports.ERPToJSON = ERPToJSON;
